import { HorizontalRule } from "@asosteam/asos-web-component-library-horizontal-rule";
import styles from "./styles";
import ChevronRight from "../../assets/chevron-right.svg";
import classnames from "classnames";
import { useJoinStatus } from "../../context/join-status";
import global from "../../styles";
import { useLocaleProvider, useTranslate } from "../../context/locale-provider";

const faqItem = ({ faq, url }) => {
  return (
    <div key={faq}>
      <HorizontalRule overspill={false} />
      <a href={url} className={styles.faqLink} target="_blank" rel="noreferrer">
        <div className={styles.faqLinkWrapper}>
          <div className={global.leavesden2}>{faq}</div>
          <div className={styles.chevron}>
            <ChevronRight />
          </div>
        </div>
      </a>
    </div>
  );
};

const getFaqs = (translate, localisedLinks) => [
  {
    faq: translate("loyalty_landing_page_faqs_membership"),
    url: localisedLinks.faqHowToJoin,
  },
  {
    faq: translate("loyalty_landing_page_faqs_tiers"),
    url: localisedLinks.faqMoveTiers,
  },
  {
    faq: translate("loyalty_landing_page_faqs_benefits"),
    url: localisedLinks.faqBenefitInfo,
  },
  {
    faq: translate("loyalty_landing_page_faqs_tier_progression"),
    url: localisedLinks.faqTierProgression,
  },
];

const Faqs = () => {
  const { languageStrings, localisedLinks } = useLocaleProvider();
  const translate = useTranslate({ languageStrings });
  const [state] = useJoinStatus();
  return (
    <div
      className={classnames(styles.CardHeadingContainer, {
        [styles.fixed]: state.showSuccess,
      })}
    >
      <div className={styles.faqHeaderWrapper}>
        <h3 className={classnames(global.london1, styles.faqHeader)}>
          {translate("loyalty_landing_page_faqs_header")}
        </h3>
      </div>

      {getFaqs(translate, localisedLinks).map((faq) => faqItem(faq))}
      <h3 className={classnames(global.london1, styles.getInTouch)}>
        {translate("loyalty_landing_page_contact_us_header")}
      </h3>

      <div className={styles.contactUsNowContainer}>
        <div className={styles.contactUsNow}>
          <a
            href={localisedLinks.customerCareGetInTouch}
            className={styles.contactUsNowLink}
            target="_blank"
            rel="noreferrer"
          >
            {translate("loyalty_landing_page_contact_us_button")}
          </a>
        </div>
      </div>
    </div>
  );
};

export default Faqs;
